function cov_8n0aqs5dh() {
  var path = "/app/src/hooks/use-locale.ts";
  var hash = "ee4235079f203dc168940a8fd3f25296ff2a81a0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/hooks/use-locale.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 27
        },
        end: {
          line: 6,
          column: 42
        }
      },
      "2": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 69
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 25
          },
          end: {
            line: 5,
            column: 26
          }
        },
        loc: {
          start: {
            line: 5,
            column: 31
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 5
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ee4235079f203dc168940a8fd3f25296ff2a81a0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_8n0aqs5dh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_8n0aqs5dh();
import { useCallback } from 'react';
import { useAppContext } from 'src/context/store/app-provider';
import { getTranslationFn } from 'src/utils/get-translation-fn';
cov_8n0aqs5dh().s[0]++;
export var useLocale = function useLocale() {
  cov_8n0aqs5dh().f[0]++;
  var _ref = (cov_8n0aqs5dh().s[1]++, useAppContext()),
    lang = _ref.lang,
    locale = _ref.locale;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  cov_8n0aqs5dh().s[2]++;
  return useCallback(getTranslationFn(lang, locale), [lang, locale]);
};